import { getFromLocalStorage, removeFromLocalStorageByKey, saveToLocalStorage } from "shared/utils/localStorageUtils";

const useLocalStorage = () => {
  const saveValueToLocalStorage = (key: string, value: any) => {
    saveToLocalStorage(key, value);
  };

  const getValueFromLocalStorage = (key: string) => {
    return getFromLocalStorage(key);
  };

  const removeStoredValueByKey = (key: string) => {
    removeFromLocalStorageByKey(key);
  };

  return { saveValueToLocalStorage, getValueFromLocalStorage, removeStoredValueByKey };
};

export default useLocalStorage;
